import { BaSeBreakpointContext } from '@base/react';
import React from 'react';

export function useDisplay() {
  const breakpointController = React.useContext(BaSeBreakpointContext);

  function isLargeDisplay() {
    return (
      breakpointController.inDesktop ||
      breakpointController.inDesktopLarge ||
      breakpointController.inTablet
    );
  }

  return {
    isLargeDisplay,
    breakpointController,
  };
}
